// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-dash {
  width: 100%;
  margin-top: 4px;
  padding: 12px;
  border: 1px solid #cfe2ff;
  border-radius: 14px;
  background: linear-gradient(180deg, #f7fbff 0%, #ffffff 48%);
  box-shadow: 0 1px 4px rgba(30, 113, 187, 0.06);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ai-dash__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.ai-dash__title-left {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.ai-dash__grid-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #e7f1ff;
  color: #1e71bb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;
  margin-top: 1px;
}

.ai-dash__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #16223a;
  line-height: 1.3;
  word-break: break-word;
}

.ai-dash__subtitle {
  margin: 2px 0 0;
  font-size: 11px;
  color: #6c757d;
}

.ai-dash__live {
  flex-shrink: 0;
  background: #1e71bb;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 4px 10px;
  border-radius: 999px;
  line-height: 1;
}

.ai-dash__summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
  padding: 12px;
  border: 1px solid #e3eefc;
  border-radius: 12px;
  background: #ffffff;
}

.ai-dash__summary-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ai-dash__summary-label {
  font-size: 10px;
  font-weight: 600;
  color: #8a94a6;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.ai-dash__summary-value {
  font-size: 13px;
  font-weight: 600;
  color: #212529;
  word-break: break-word;
}

.ai-dash__summary-value--accent {
  color: #1e71bb;
}

.ai-dash__summary-value--status {
  color: #0d9488;
  font-weight: 700;
}

.ai-dash__kpis {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.ai-dash__kpi {
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ai-dash__kpi-label {
  font-size: 11px;
  color: #6c757d;
  font-weight: 500;
  line-height: 1.25;
}

.ai-dash__kpi-value {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.1;
}

.ai-dash__kpi--blue .ai-dash__kpi-value {
  color: #1e71bb;
}

.ai-dash__kpi--green .ai-dash__kpi-value {
  color: #16a34a;
}

.ai-dash__kpi--orange .ai-dash__kpi-value {
  color: #ea580c;
}

.ai-dash__kpi--teal .ai-dash__kpi-value {
  color: #0d9488;
}

.ai-dash__charts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.ai-dash__chart-card {
  padding: 10px;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  background: #ffffff;
  min-height: 140px;
}

.ai-dash__chart-title {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 700;
  color: #16223a;
}

.ai-dash__chart-empty {
  font-size: 12px;
  color: #adb5bd;
  padding: 24px 0;
  text-align: center;
}

.ai-dash__donut-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ai-dash__donut-chart {
  width: 72px;
  height: 72px;
  flex-shrink: 0;
}

.ai-dash__donut-legend {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1 1;
}

.ai-dash__donut-legend-row {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
}

.ai-dash__donut-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ai-dash__donut-name {
  color: #495057;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1;
  min-width: 0;
}

.ai-dash__donut-pct {
  color: #16223a;
  font-weight: 600;
  flex-shrink: 0;
}

.ai-dash__bars {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ai-dash__bar-row {
  display: grid;
  grid-template-columns: 36px 1fr 40px;
  align-items: center;
  gap: 6px;
}

.ai-dash__bar-label {
  font-size: 11px;
  font-weight: 600;
  color: #495057;
}

.ai-dash__bar-track {
  height: 8px;
  border-radius: 999px;
  background: #eef3f9;
  overflow: hidden;
}

.ai-dash__bar-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #3b82f6, #1e71bb);
}

.ai-dash__bar-value {
  font-size: 11px;
  font-weight: 600;
  color: #16223a;
  text-align: right;
}

.ai-dash__lines {
  border: 1px solid #e3eefc;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.ai-dash__lines-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  background: #f0f7ff;
  border-bottom: 1px solid #e3eefc;
}

.ai-dash__lines-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #16223a;
}

.ai-dash__lines-title i {
  color: #1e71bb;
}

.ai-dash__lines-count {
  font-size: 11px;
  font-weight: 600;
  color: #1e71bb;
  background: #ffffff;
  border: 1px solid #cfe2ff;
  border-radius: 999px;
  padding: 2px 8px;
}

.ai-dash__lines-empty {
  padding: 16px 12px;
  font-size: 12px;
  color: #6c757d;
  text-align: center;
}

.ai-dash__table-wrap {
  overflow-x: auto;
}

.ai-dash__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.ai-dash__table th {
  text-align: left;
  padding: 8px 10px;
  font-size: 10px;
  font-weight: 700;
  color: #8a94a6;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  background: #fafcff;
  border-bottom: 1px solid #eef2f7;
}

.ai-dash__table td {
  padding: 8px 10px;
  color: #1e71bb;
  border-bottom: 1px solid #eef5ff;
  vertical-align: top;
  word-break: break-word;
}

.ai-dash__table tbody tr:last-child td {
  border-bottom: none;
}

.ai-dash__sku {
  font-weight: 700;
  white-space: nowrap;
}

.ai-assistant__bubble--ai:has(.ai-dash) {
  padding: 10px;
  max-width: 100%;
}

.ai-assistant__message-content:has(.ai-dash) {
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/AiAssistant/ModuleDashboard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4DAA4D;EAC5D,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".ai-dash {\n  width: 100%;\n  margin-top: 4px;\n  padding: 12px;\n  border: 1px solid #cfe2ff;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #f7fbff 0%, #ffffff 48%);\n  box-shadow: 0 1px 4px rgba(30, 113, 187, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ai-dash__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.ai-dash__title-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  min-width: 0;\n}\n\n.ai-dash__grid-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: #e7f1ff;\n  color: #1e71bb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 13px;\n  margin-top: 1px;\n}\n\n.ai-dash__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #16223a;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.ai-dash__subtitle {\n  margin: 2px 0 0;\n  font-size: 11px;\n  color: #6c757d;\n}\n\n.ai-dash__live {\n  flex-shrink: 0;\n  background: #1e71bb;\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 4px 10px;\n  border-radius: 999px;\n  line-height: 1;\n}\n\n.ai-dash__summary {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 12px;\n  padding: 12px;\n  border: 1px solid #e3eefc;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.ai-dash__summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.ai-dash__summary-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #8a94a6;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.ai-dash__summary-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #212529;\n  word-break: break-word;\n}\n\n.ai-dash__summary-value--accent {\n  color: #1e71bb;\n}\n\n.ai-dash__summary-value--status {\n  color: #0d9488;\n  font-weight: 700;\n}\n\n.ai-dash__kpis {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.ai-dash__kpi {\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ai-dash__kpi-label {\n  font-size: 11px;\n  color: #6c757d;\n  font-weight: 500;\n  line-height: 1.25;\n}\n\n.ai-dash__kpi-value {\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.1;\n}\n\n.ai-dash__kpi--blue .ai-dash__kpi-value {\n  color: #1e71bb;\n}\n\n.ai-dash__kpi--green .ai-dash__kpi-value {\n  color: #16a34a;\n}\n\n.ai-dash__kpi--orange .ai-dash__kpi-value {\n  color: #ea580c;\n}\n\n.ai-dash__kpi--teal .ai-dash__kpi-value {\n  color: #0d9488;\n}\n\n.ai-dash__charts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.ai-dash__chart-card {\n  padding: 10px;\n  border: 1px solid #e9ecef;\n  border-radius: 12px;\n  background: #ffffff;\n  min-height: 140px;\n}\n\n.ai-dash__chart-title {\n  margin: 0 0 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #16223a;\n}\n\n.ai-dash__chart-empty {\n  font-size: 12px;\n  color: #adb5bd;\n  padding: 24px 0;\n  text-align: center;\n}\n\n.ai-dash__donut-wrap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ai-dash__donut-chart {\n  width: 72px;\n  height: 72px;\n  flex-shrink: 0;\n}\n\n.ai-dash__donut-legend {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n}\n\n.ai-dash__donut-legend-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n}\n\n.ai-dash__donut-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.ai-dash__donut-name {\n  color: #495057;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n  min-width: 0;\n}\n\n.ai-dash__donut-pct {\n  color: #16223a;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.ai-dash__bars {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ai-dash__bar-row {\n  display: grid;\n  grid-template-columns: 36px 1fr 40px;\n  align-items: center;\n  gap: 6px;\n}\n\n.ai-dash__bar-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.ai-dash__bar-track {\n  height: 8px;\n  border-radius: 999px;\n  background: #eef3f9;\n  overflow: hidden;\n}\n\n.ai-dash__bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #3b82f6, #1e71bb);\n}\n\n.ai-dash__bar-value {\n  font-size: 11px;\n  font-weight: 600;\n  color: #16223a;\n  text-align: right;\n}\n\n.ai-dash__lines {\n  border: 1px solid #e3eefc;\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.ai-dash__lines-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  background: #f0f7ff;\n  border-bottom: 1px solid #e3eefc;\n}\n\n.ai-dash__lines-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #16223a;\n}\n\n.ai-dash__lines-title i {\n  color: #1e71bb;\n}\n\n.ai-dash__lines-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: #1e71bb;\n  background: #ffffff;\n  border: 1px solid #cfe2ff;\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.ai-dash__lines-empty {\n  padding: 16px 12px;\n  font-size: 12px;\n  color: #6c757d;\n  text-align: center;\n}\n\n.ai-dash__table-wrap {\n  overflow-x: auto;\n}\n\n.ai-dash__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.ai-dash__table th {\n  text-align: left;\n  padding: 8px 10px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #8a94a6;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  background: #fafcff;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.ai-dash__table td {\n  padding: 8px 10px;\n  color: #1e71bb;\n  border-bottom: 1px solid #eef5ff;\n  vertical-align: top;\n  word-break: break-word;\n}\n\n.ai-dash__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.ai-dash__sku {\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.ai-assistant__bubble--ai:has(.ai-dash) {\n  padding: 10px;\n  max-width: 100%;\n}\n\n.ai-assistant__message-content:has(.ai-dash) {\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
